import { render, staticRenderFns } from "./input-date.vue?vue&type=template&id=b3d987f6&scoped=true&"
import script from "./input-date.vue?vue&type=script&lang=js&"
export * from "./input-date.vue?vue&type=script&lang=js&"
import style0 from "./input-date.vue?vue&type=style&index=0&id=b3d987f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d987f6",
  null
  
)

export default component.exports